import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import EmptyRow from "../../components/emptyRow/EmptyRow";

const Sitemap = () => {
  return (
    <>
      <Row>
        <Col sm={12} xs={12}>
          <h4>Sitemap</h4>
        </Col>
      </Row>
      <EmptyRow />
      <div className=" b_shadow p_all" style={styles.DivGrey}>
        <Row>
          <Col sm={12} xs={12}>
            <h4>Home</h4>
          </Col>
        </Row>
      </div>
      <div className="bgwhite b_shadow p_all">
        <Row>
          <Col sm={12} xs={12}>
            <p>Home</p>
          </Col>
        </Row>
      </div>{" "}
      <br />
      <div className=" b_shadow p_all" style={styles.DivGrey}>
        <Row>
          <Col sm={12} xs={12}>
            <h4>Ethics Policies</h4>
          </Col>
        </Row>
      </div>
      <div className="bgwhite b_shadow p_all">
        <Row>
          <Col sm={12} xs={12}>
            <p>Policy Details</p>
          </Col>
        </Row>
      </div>{" "}
      <br />
      <div className=" b_shadow p_all" style={styles.DivGrey}>
        <Row>
          <Col sm={12} xs={12}>
            <h4>Ethics Awareness</h4>
          </Col>
        </Row>
      </div>
      <div className="bgwhite b_shadow p_all">
        <Row>
          <Col sm={12} xs={12}>
            <p>Learning Modules Details</p>
            <p>Ethics Counsellor Learning Program Details</p>
            <p>Video Details</p>
            <p>Document Details</p>
          </Col>
        </Row>
      </div>
      <br />
      <div className=" b_shadow p_all" style={styles.DivGrey}>
        <Row>
          <Col sm={12} xs={12}>
            <h4> Ethics counsellors</h4>
          </Col>
        </Row>
      </div>
      <div className="bgwhite b_shadow p_all">
        <Row>
          <Col sm={12} xs={12}>
            <p>Document Details</p>
          </Col>
        </Row>
      </div>
    </>
  );
};

const styles: any = {
  DivGrey: {
    backgroundColor: "#fcfbfb",
    border: "1px solid #eee",
  },

  imp: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "0px",
  },

  content: { marginTop: "20px" },
};

export default Sitemap;
